module.exports = __webpack_public_path__ + "static/media/cardMarital.a7c67a65.png";